export const COLORS = {
    GRID_HEADER_BACKGROUND: '#D8E7FF',
}